import { ContentCard } from '../../../components/ContentCard/ContentCard';
import SanitizedHtml from '../../SanitizedHtml/SanitizedHtml';
import './CmsCard.css';
import { CmsMeta } from '../cmsMeta';

type CmsCardProps = {
	heading: string;
	textMarkup: string;
	imageSrc: string;
	cardType: 'type-1' | 'type-2';
};
export const CmsCard = ({ heading, textMarkup, imageSrc, cardType }: CmsCardProps): JSX.Element => {
	return (
		<div className={'cms-card ' + cardType}>
			<div className="cms-card-banner">
				<img src={imageSrc} />
			</div>
			<ContentCard className="cms-card-text">
				<h1>{heading}</h1>
				<SanitizedHtml html={textMarkup} />
			</ContentCard>
		</div>
	);
};

export const cmsMeta: CmsMeta = {
	description:
		"A picture beside a green card with a heading and text, for introducing a service or an offer. `cardType` sets the picture's size on desktop: type-1 is narrow and short, type-2 is wide and tall. `textMarkup` takes simple html.",
	example: [
		'CmsCard',
		{
			cardType: 'type-1',
			imageSrc: 'https://cdn.ondio.com/assets/e2460c24232349ac95f25b3f47bb2c38.jpg',
			heading: 'Tjänster för ditt kontor',
			textMarkup:
				'<p>Fruktkorgar, kaffelösningar och städning, som ni kan kombinera, pausa och skala upp eller ner efter behov.</p>',
		},
	],
};
